import {useQuery} from "@tanstack/react-query";
import {fetchGraphQL} from "../../../utils/gql-utils";
import {getGraphQLUrl} from "../../../web3/apollo/client";
import { mapTxType, txFragment } from "./transactions.utils";

export const useGetTransactionsFilteredV2Data = (enabled?: boolean, pairs?: string[]) => {
  const query = useQuery({
    queryKey: ["transactions-filtered-v2", pairs?.join(',')],
    queryFn: async () => {
      const url = getGraphQLUrl();
      const common = "orderBy: timestamp, orderDirection: desc, first: 20"
      return await fetchGraphQL(
        url,
        `
        query ($allPairs: [Bytes]!) {
          mints(${common}, where: { pair_in: $allPairs }) {
            ${txFragment('mint')}
          }
          burns(${common}, where: { pair_in: $allPairs }) {
            ${txFragment('burn')}
          }
          swaps(${common}, where: { pair_in: $allPairs }) {
            ${txFragment('swap')}
          }
        }
      `,
        {allPairs: pairs}
      ).then(({data}: {data: Record<string, any[]>}) => {
        const {mints, burns, swaps} = data;
        return [...mapTxType("mints", mints), ...mapTxType("burns", burns), ...mapTxType("swaps", swaps)]
          .map((_, i) => ({..._, index: i}))
          .flat()
      });
    },
    enabled,
    refetchOnWindowFocus: false,
  });

  return {
    ...query,
    txs: query.data || [],
  };
};
